module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Legion-S2.4e5208b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Legion-S2.jpg
// module id = I/fv
// module chunks = 0